<template>
<div class="mt-2">
    <v-layout justify-center align-center>
        <!-- <v-flex>
        <v-btn @click="ExcecuteBilling('1st')">1st</v-btn>
        <v-btn @click="ExcecuteBilling('7th')">7th</v-btn>
        <v-btn @click="ExcecuteBilling('15th')">15th</v-btn>
        <v-btn @click="ExcecuteBilling('25th')">25th</v-btn>
    </v-flex> -->
        <v-flex xs12 md4 lg3>
            <linechart v-if="loaded" :chartdata="arpuData" :options="arpuOptions">
            </linechart>

        </v-flex>
        <v-flex xs12 md4 lg3>
            <barchart v-if="loaded" :chartdata="salesData" :options="salesOptions">
            </barchart>

        </v-flex>
        <v-flex xs12 md4 lg3>
            <barchart v-if="loaded" :chartdata="unitsData" :options="unitOptions">
            </barchart>

        </v-flex>
        <v-flex xs12 md4 lg3>
            <v-card class="ma-2">
                <!-- <v-card-title>Growth</v-card-title> -->
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs3>
                        </v-flex>
                        <v-flex xs3>
                            <span>3 Months</span>
                        </v-flex>
                        <v-flex xs3>
                            <span>6 Months</span>

                        </v-flex>
                        <v-flex xs3>
                            <span>12 Months</span>

                        </v-flex>
                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>Sales</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthCount(3)>0" style="fontSize: 12px; color: green">{{CalculateRevenueGrowthCount(3)|currency}}</span>
                            <span v-else-if="CalculateRevenueGrowthCount(3)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthCount(3)|currency}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthCount(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateRevenueGrowthCount(6)|currency}}</span>
                            <span v-else-if="CalculateRevenueGrowthCount(6)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthCount(6)|currency}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthCount(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateRevenueGrowthCount(12)|currency}}</span>
                            <span v-else-if="CalculateRevenueGrowthCount(12)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthCount(12)|currency}}</span>
                            <span v-else>-</span>
                        </v-flex>

                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>ARPU</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUCount(3)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUCount(3)|currency}}</span>
                            <span v-else-if="CalculateARPUCount(3)<0" style="fontSize: 12px; color: red">{{CalculateARPUCount(3)|currency}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUCount(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUCount(6)|currency}}</span>
                            <span v-else-if="CalculateARPUCount(6)<0" style="fontSize: 12px; color: red">{{CalculateARPUCount(6)|currency}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUCount(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUCount(12)|currency}}</span>
                            <span v-else-if="CalculateARPUCount(12)<0" style="fontSize: 12px; color: red">{{CalculateARPUCount(12)|currency}}</span>
                            <span v-else>-</span>
                        </v-flex>

                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>Accounts</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsCount(3)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsCount(3)}}</span>
                            <span v-else-if="CalculateLiveConnectionsCount(3)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsCount(3)}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsCount(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsCount(6)}}</span>
                            <span v-else-if="CalculateLiveConnectionsCount(6)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsCount(6)}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsCount(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsCount(12)}}</span>
                            <span v-else-if="CalculateLiveConnectionsCount(12)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsCount(12)}}</span>
                            <span v-else>-</span>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card class="ma-2">
                <!-- <v-card-title>Growth</v-card-title> -->
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs3>
                        </v-flex>
                        <v-flex xs3>
                            <span>3 Months</span>
                        </v-flex>
                        <v-flex xs3>
                            <span>6 Months</span>

                        </v-flex>
                        <v-flex xs3>
                            <span>12 Months</span>

                        </v-flex>
                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>Sales</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthPeriod(3)>0" style="fontSize: 12px; color: green">{{'+'+CalculateRevenueGrowthPeriod(3)+'%'}}</span>
                            <span v-else-if="CalculateRevenueGrowthPeriod(3)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthPeriod(3)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthPeriod(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateRevenueGrowthPeriod(6)+'%'}}</span>
                            <span v-else-if="CalculateRevenueGrowthPeriod(6)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthPeriod(6)+'%'}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateRevenueGrowthPeriod(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateRevenueGrowthPeriod(12)+'%'}}</span>
                            <span v-else-if="CalculateRevenueGrowthPeriod(12)<0" style="fontSize: 12px; color: red">{{CalculateRevenueGrowthPeriod(12)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>

                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>ARPU</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUPeriod(3)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUPeriod(3)+'%'}}</span>
                            <span v-else-if="CalculateARPUPeriod(3)<0" style="fontSize: 12px; color: red">{{CalculateARPUPeriod(3)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUPeriod(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUPeriod(6)+'%'}}</span>
                            <span v-else-if="CalculateARPUPeriod(6)<0" style="fontSize: 12px; color: red">{{CalculateARPUPeriod(6)+'%'}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateARPUPeriod(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateARPUPeriod(12)+'%'}}</span>
                            <span v-else-if="CalculateARPUPeriod(12)<0" style="fontSize: 12px; color: red">{{CalculateARPUPeriod(12)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>

                        <!-- Sales -->
                        <v-flex xs3 class="text-xs-left">
                            <h4>Accounts</h4>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsPeriod(3)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsPeriod(3)+'%'}}</span>
                            <span v-else-if="CalculateLiveConnectionsPeriod(3)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsPeriod(3)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsPeriod(6)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsPeriod(6)+'%'}}</span>
                            <span v-else-if="CalculateLiveConnectionsPeriod(6)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsPeriod(6)+'%'}}</span>
                            <span v-else>-</span>

                        </v-flex>
                        <v-flex xs3>
                            <span v-if="CalculateLiveConnectionsPeriod(12)>0" style="fontSize: 12px; color: green">{{'+'+CalculateLiveConnectionsPeriod(12)+'%'}}</span>
                            <span v-else-if="CalculateLiveConnectionsPeriod(12)<0" style="fontSize: 12px; color: red">{{CalculateLiveConnectionsPeriod(12)+'%'}}</span>
                            <span v-else>-</span>
                        </v-flex>

                    </v-layout>
                </v-card-text>
            </v-card>

            <v-card class="ma-2">
                <v-card-title style="font-weight: bold; padding-bottom: 0">Projected Sales: <span style="font-weight: light; margin: 0; padding: 0; padding-left: 10px">{{projected.period}}</span></v-card-title>

                <v-card-text class="ma-0">
                    <v-progress-circular v-if="loadingProjected" color="primary" indeterminate></v-progress-circular>
                    <v-layout v-else wrap justify-start>
                        <v-flex xs6 class="text-xs-left">
                            <h4>Once Off Sales:</h4>
                        </v-flex>
                        <v-flex xs6 class="text-xs-left">
                            <span>{{projected.totalOnceOff | currency}}</span>
                        </v-flex>
                        <v-flex xs6 class="text-xs-left">
                            <h4>Recurring:</h4>
                        </v-flex>
                        <v-flex xs6 class="text-xs-left">
                            <span>{{projected.totalRecurring | currency}}</span>
                        </v-flex>
                        <v-flex xs6 class="text-xs-left">
                            <h4>Total:</h4>
                        </v-flex>
                        <v-flex xs6 class="text-xs-left">
                            <span><u>{{projected.totalRevenue | currency}}</u></span>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
    <v-flex>
        <v-data-table :headers="headers" class="elevation-1" :pagination.sync="pagination" :items="billingSummary" :rows-per-page-items="[12, 25]" item-key="id" align-center disable-initial-sort style="cursor: pointer">
            <template v-slot:items="props">
                <td class="text-xs-left" @click="routeToBreakdown(props.item)">{{props.item.periodStart}} to {{props.item.periodEnd}}</td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">
                    <v-chip v-if="props.item.status=='Pending'" style="color: orange" outline>{{props.item.status}}</v-chip>
                    <v-chip v-else-if="props.item.status=='Approved'" color="success" outline>{{props.item.status}}</v-chip>
                </td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">{{props.item.unitsPassed}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsPassed(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsPassed(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsPassed(props.item,billingSummary[props.index+1])<0">{{CalculateUnitsPassed(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">{{props.item.unitsConnected}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsConnected(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsConnected(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsConnected(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">{{props.item.unitsLive}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateUnitsLive(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateUnitsLive(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateUnitsLive(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" style="fontSize: 14px" @click="routeToBreakdown(props.item)">{{props.item.averageReturnPerUnit|currency}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateARPU(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateARPU(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateARPU(props.item,billingSummary[props.index+1])<0">{{CalculateARPU(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)" style="padding: 10px">{{props.item.totalRevenue|currency}}<br><span outline style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateRevenueGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">{{props.item.totalRecurring|currency}} <br> <span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateRevenueGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateRecurringGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="props.index!=billingSummary.length-1&&CalculateRecurringGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateRecurringGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
                <td class="text-xs-center" @click="routeToBreakdown(props.item)">{{props.item.totalOnceOff|currency}}<br><span style="height:20px; fontSize: 12px; color: green" v-if="props.index!=billingSummary.length-1&&CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])>0">{{'+'+ CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])+'%'}}</span><span style="height:20px; fontSize: 12px; color: red" v-else-if="(props.index!=billingSummary.length-1)&&CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])<0">{{CalculateOnceOffGrowth(props.item,billingSummary[props.index+1])+'%'}}</span></td>
            </template>
            <template v-slot:pageText="props">Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
        </v-data-table>
    </v-flex>

</div>
</template>

<script>
import Api from "@/services/Api";
import BarChart from "./BarChart.vue";
import PieChart from "./PieChart.vue";
import LineChart from "./LineChart.vue";
import dateformat from "dateformat";
import DoughnutChart from "./DoughnutChart.vue";
export default {
    components: {
        barchart: BarChart,
        piechart: PieChart,
        linechart: LineChart,
        doughnutchart: DoughnutChart
    },
    data() {
        return {
            arpuData: {},
            arpuOptions: {},
            billingSettings: {},
            salesData: {},
            salesData: {},
            unitsData: {},
            unitOptions: {},
            projected: {},
            loadingProjected: false,
            loaded: false,
            billingSummary: [],
            today: new Date(2021, 10, 30),
            lastMonth: new Date(),
            headers: [{
                    text: "Billing Period",
                    // align: "start",
                    value: "periodEnd"
                },
                {
                    text: "Status",
                    align: "center",
                    value: "status"
                },
                {
                    text: "Units Passed",
                    align: "center",
                    value: "unitsPassed"
                },
                {
                    text: "Units Connected",
                    align: "center",
                    value: "unitsConnected"
                },

                {
                    text: "Live Connections",
                    align: "center",
                    value: "unitsLive"
                },
                {
                    text: "ARPU",
                    align: "center",
                    value: "averageReturnPerUnit"
                },
                {
                    text: "Total Sales",
                    align: "center",
                    value: "totalRevenue"
                },
                {
                    text: "Recurring Sales",
                    align: "center",
                    value: "totalRecurring"
                },
                {
                    text: "Once-off Sales",
                    align: "center",
                    value: "totalOnceOff"
                }
            ],

        }
    },
    created() {
        this.lastMonth.setDate(this.today.getDate() - 30)
        this.fetchBillingSummaries()
        this.fetchBillingSettings()
    },
    methods: {
        fetchBillingSettings() {
            Api().get('/organisation/billingSettings').then(async res => {
                this.billingSettings = res.data
                let billing = this.getBillingDates(this.billingSettings.billingDay, this.billingSettings.includeBillingDay)
                this.billingSettings.startDate = billing.startDate
                this.billingSettings.endDate = billing.endDate
                this.projectedSales()
            })
        },
        ExcecuteBilling(day) {
            switch (day) {
                case '1st':
                    var today = new Date()
                    // today.setMonth(today.getMonth()-5)
                    today.setMonth(today.getMonth() - 1)
                    today.setDate(1)
                    console.log(today)
                    var eom = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    console.log('From ' + today.getDate() + ' to ' + eom.getDate())
                    let startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    let endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()

                    runBilling(startDate, endDate)
                    break
                case '25th':
                    var today = new Date()
                    if (this.billingSettings.includeBillingDay) {
                        today.setDate(26)
                    } else {
                        today.setDate(25)
                    }
                    today.setMonth(today.getMonth() - 2)
                    var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                    eom.setDate(today.getDate() - 1)
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    this.runBilling(startDate, endDate)
                    break
                case '15th':
                    var today = new Date()
                    today.setDate(15)
                    var lm = new Date()
                    lm.setDate(15)
                    lm.setMonth(today.getMonth() - 1)
                    console.log(this.datediff(lm, today))
                    break
            }
        },
        async fetchBillingSummaries() {
            await Api().get('/billingSummary').then(res => {
                this.billingSummary = res.data
                this.loadCharts()
            })
        },
        datediff(first, second) {
            // Take the difference between the dates and divide by milliseconds per day.
            // Round to nearest whole number to deal with DST.
            return Math.round((second - first) / (1000 * 60 * 60 * 24));
        },
        async runBilling(start, end) {
            await Api().post('/billingSummary/run', {
                billingStart: start,
                billingEnd: end
            }).then(res => {
                console.log(res.data)
                // this.billingSummary = res.data
            })

        },
        getBillingDates(billingDay, includeBillingDay) {
            var today = new Date()
            let startDate = null
            let endDate = null
            switch (billingDay) {
                case '1st':
                    today.setMonth(today.getMonth())
                    today.setDate(1)
                    console.log(today)
                    var eom = new Date(today.getFullYear(), today.getMonth() + 1, 0)
                    console.log('From ' + today.getDate() + ' to ' + eom.getDate())
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                    endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                    return {
                        startDate: startDate, endDate: endDate
                    }
                    case '7th':
                        if (includeBillingDay) {
                            today.setDate(8)
                        } else {
                            today.setDate(7)
                        }
                        today.setMonth(today.getMonth() - 2)
                        var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                        eom.setDate(today.getDate() - 1)
                        startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                        endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                        return {
                            startDate: startDate, endDate: endDate
                        }
                        case '15th':
                            if (includeBillingDay) {
                                today.setDate(16)
                            } else {
                                today.setDate(15)
                            }
                            today.setMonth(today.getMonth() - 1)
                            var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                            eom.setDate(today.getDate() - 1)
                            startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                            endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                            return {
                                startDate: startDate, endDate: endDate
                            }
                            case '25th':
                                if (includeBillingDay) {
                                    today.setDate(26)
                                } else {
                                    today.setDate(25)
                                }
                                today.setMonth(today.getMonth() - 1)
                                var eom = new Date(today.getFullYear(), today.getMonth() + 1, today.getDate() + 1)
                                eom.setDate(today.getDate() - 1)
                                startDate = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
                                endDate = eom.getFullYear() + '-' + (eom.getMonth() + 1 + '-') + eom.getDate()
                                return {
                                    startDate: startDate, endDate: endDate
                                }
            }
        },
        async projectedSales() {
            this.loadingProjected = true
            await Api().post('/billingSummary/indicative/run', {
                billingStart: this.billingSettings.startDate,
                billingEnd: this.billingSettings.endDate
            }).then(res => {
                this.projected = res.data
                this.loadingProjected = false
            })
        },
        CalculateRevenueGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalRevenue - lastMonth.totalRevenue) / lastMonth.totalRevenue) * 10000) / 100
        },
        CalculateRevenueGrowthPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.totalRevenue - end.totalRevenue) / end.totalRevenue) * 10000) / 100

            } else {
                return undefined
            }
        },

        CalculateRevenueGrowthCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.totalRevenue - end.totalRevenue
            } else {
                return undefined
            }
        },

        CalculateARPUPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.averageReturnPerUnit - end.averageReturnPerUnit) / end.averageReturnPerUnit) * 10000) / 100

            } else {
                return undefined
            }
        },
        CalculateARPUCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.averageReturnPerUnit - end.averageReturnPerUnit
            } else {
                return undefined
            }
        },
        CalculateLiveConnectionsPeriod(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return Math.round(((start.unitsLive - end.unitsLive) / end.unitsLive) * 10000) / 100

            } else {
                return undefined
            }
        },
        CalculateLiveConnectionsCount(period) {
            let start = this.billingSummary[0]
            let end = this.billingSummary[period - 1]
            if (end) {
                return start.unitsLive - end.unitsLive

            } else {
                return undefined
            }
        },
        CalculateRecurringGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalRecurring - lastMonth.totalRecurring) / lastMonth.totalRecurring) * 10000) / 100
        },
        CalculateOnceOffGrowth(currentMonth, lastMonth) {
            return Math.round(((currentMonth.totalOnceOff - lastMonth.totalOnceOff) / lastMonth.totalOnceOff) * 10000) / 100
        },
        CalculateUnitsPassed(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsPassed - lastMonth.unitsPassed) / lastMonth.unitsPassed) * 10000) / 100
        },
        CalculateUnitsConnected(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsConnected - lastMonth.unitsConnected) / lastMonth.unitsConnected) * 10000) / 100
        },
        CalculateUnitsLive(currentMonth, lastMonth) {
            return Math.round(((currentMonth.unitsLive - lastMonth.unitsLive) / lastMonth.unitsLive) * 10000) / 100
        },
        CalculateARPU(currentMonth, lastMonth) {
            return Math.round(((currentMonth.averageReturnPerUnit - lastMonth.averageReturnPerUnit) / lastMonth.averageReturnPerUnit) * 10000) / 100
        },
        routeToBreakdown(item) {
            console.log(item)
            this.$router.push({
                path: "/billingBreakdown/" + item.id
            });
        },
        loadCharts() {
            this.arpuData = {
                labels: this.billingSummary.map(x => x.periodEnd).reverse(),
                datasets: [{
                    label: "ARPU",
                    data: this.billingSummary.map(x => x.averageReturnPerUnit).reverse(),
                    backgroundColor: this.pSBC(0.35, '#072aab'),
                    borderColor: '#072aab',
                    borderWidth: 1
                }]
            }
            this.arpuOptions = {
                title: {
                    display: true,
                    text: "Average Revenue per Unit"
                },
                //  scales: {
                //   yAxes: [
                //     {
                //       ticks: {
                //         beginAtZero: true,
                //       }}]}
            }

            this.salesData = {
                labels: this.billingSummary.map(x => x.periodEnd).reverse(),
                datasets: [{
                        label: "Recurring",
                        data: this.billingSummary.map(x => x.totalRecurring).reverse(),
                        backgroundColor: this.pSBC(0.35, '#2aa9d4'),
                        borderColor: '#2aa9d4',
                        borderWidth: 1
                    },
                    {
                        label: "Once Off",
                        data: this.billingSummary.map(x => x.totalOnceOff).reverse(),
                        backgroundColor: this.pSBC(0.35, '#0a7cff'),
                        borderColor: '#0a7cff',
                        borderWidth: 1
                    }
                ]
            }
            this.salesOptions = {
                title: {
                    display: true,
                    text: "Monthly Revenue"
                },
                scales: {
                    xAxes: [{
                        stacked: true,
                        categoryPercentage: 0.8,
                        barPercentage: 1
                    }],
                    yAxes: [{
                        stacked: true,
                    }]
                }
            }

            this.unitsData = {
                labels: this.billingSummary.map(x => x.periodEnd).reverse(),
                datasets: [{
                        label: "Passed",
                        data: this.billingSummary.map(x => x.unitsPassed).reverse(),
                        backgroundColor: this.pSBC(0.35, '#eb4034'),
                        borderColor: '#eb4034',
                        borderWidth: 1
                    },
                    {
                        label: "Connected",
                        data: this.billingSummary.map(x => x.unitsConnected).reverse(),
                        backgroundColor: this.pSBC(0.35, '#ff770f'),
                        borderColor: '#ff770f',
                        borderWidth: 1
                    },
                    {
                        label: "Live",
                        data: this.billingSummary.map(x => x.unitsLive).reverse(),
                        backgroundColor: this.pSBC(0.35, '#0cab17'),
                        borderColor: '#0cab17',
                        borderWidth: 1
                    }
                ]
            }
            this.unitOptions = {
                title: {
                    display: true,
                    text: "Connections"
                }
            }
            this.loaded = true
        },
        pSBC(p, c0, c1, l) {
            let r,
                g,
                b,
                P,
                f,
                t,
                h,
                i = parseInt,
                m = Math.round,
                a = typeof c1 == "string";
            if (
                typeof p != "number" ||
                p < -1 ||
                p > 1 ||
                typeof c0 != "string" ||
                (c0[0] != "r" && c0[0] != "#") ||
                (c1 && !a)
            )
                return null;
            if (!this.pSBCr)
                this.pSBCr = d => {
                    let n = d.length,
                        x = {};
                    if (n > 9) {
                        ([r, g, b, a] = d = d.split(",")), (n = d.length);
                        if (n < 3 || n > 4) return null;
                        (x.r = i(r[3] == "a" ? r.slice(5) : r.slice(4))),
                        (x.g = i(g)),
                        (x.b = i(b)),
                        (x.a = a ? parseFloat(a) : -1);
                    } else {
                        if (n == 8 || n == 6 || n < 4) return null;
                        if (n < 6)
                            d =
                            "#" +
                            d[1] +
                            d[1] +
                            d[2] +
                            d[2] +
                            d[3] +
                            d[3] +
                            (n > 4 ? d[4] + d[4] : "");
                        d = i(d.slice(1), 16);
                        if (n == 9 || n == 5)
                            (x.r = (d >> 24) & 255),
                            (x.g = (d >> 16) & 255),
                            (x.b = (d >> 8) & 255),
                            (x.a = m((d & 255) / 0.255) / 1000);
                        else
                            (x.r = d >> 16),
                            (x.g = (d >> 8) & 255),
                            (x.b = d & 255),
                            (x.a = -1);
                    }
                    return x;
                };
            (h = c0.length > 9),
            (h = a ? (c1.length > 9 ? true : c1 == "c" ? !h : false) : h),
            (f = this.pSBCr(c0)),
            (P = p < 0),
            (t =
                c1 && c1 != "c" ?
                this.pSBCr(c1) :
                P ?
                {
                    r: 0,
                    g: 0,
                    b: 0,
                    a: -1
                } :
                {
                    r: 255,
                    g: 255,
                    b: 255,
                    a: -1
                }),
            (p = P ? p * -1 : p),
            (P = 1 - p);
            if (!f || !t) return null;
            if (l)
                (r = m(P * f.r + p * t.r)),
                (g = m(P * f.g + p * t.g)),
                (b = m(P * f.b + p * t.b));
            else
                (r = m((P * f.r ** 2 + p * t.r ** 2) ** 0.5)),
                (g = m((P * f.g ** 2 + p * t.g ** 2) ** 0.5)),
                (b = m((P * f.b ** 2 + p * t.b ** 2) ** 0.5));
            (a = f.a),
            (t = t.a),
            (f = a >= 0 || t >= 0),
            (a = f ? (a < 0 ? t : t < 0 ? a : a * P + t * p) : 0);
            if (h)
                return (
                    "rgb" +
                    (f ? "a(" : "(") +
                    r +
                    "," +
                    g +
                    "," +
                    b +
                    (f ? "," + m(a * 1000) / 1000 : "") +
                    ")"
                );
            else
                return (
                    "#" +
                    (
                        4294967296 +
                        r * 16777216 +
                        g * 65536 +
                        b * 256 +
                        (f ? m(a * 255) : 0)
                    )
                    .toString(16)
                    .slice(1, f ? undefined : -2)
                );
        }
    }
}
</script>
